import { render, staticRenderFns } from "./PriceMatchManualPrice.vue?vue&type=template&id=5dcbb02e&"
import script from "./PriceMatchManualPrice.vue?vue&type=script&lang=js&"
export * from "./PriceMatchManualPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports